module.exports = __webpack_public_path__ + "img/minivan.390ef412.svg";